module.exports = __webpack_public_path__ + "img/1799_share.c8f4712a.png";